import z from "zod";

const translationPath = "page.4uDlist.listGeneration.errors.";

const generationRuleSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
  },
  {
    invalid_type_error: translationPath + "generation_rule",
  },
);

export const listGenerationSchema = z.object({
  id: z.string().optional(),
  name: z.string().min(1, translationPath + "name"),
  generationRule: generationRuleSchema,
});

export type TListGenerationForm = z.infer<typeof listGenerationSchema>;
